export enum ACTION_WORKER {
  START,
  FINISH,
  START_LOAD_FILE,
  FINISH_LOAD_FILE,
  START_READ_FILE,
  FINISH_READ_FILE,
}

export interface IWorkerLocalStorage {
  currentProjectEncryptionKey: string
  projectEncryptionKeys: {
    [key: string]: string
  }
  currentConversationEncryptionKey: string
  conversationEncryptionKeys: {
    [key: string]: string
  }
  userVaultKey: string
  buildAdditionalInfoEncryptionKeys: {
    [key: string]: string
  }
  userId: string
}

export interface MultipartUploadPath {
  key: string
  uploadId: string
  rootURL: string
  parts: {
    url: string
    partNumber: number
  }[]
}
